import Vue from 'vue'
import Vuex from 'vuex'

import MainNav from './modules/mainNav'
import IsReturn from './modules/isReturn.js'
import News from './modules/news.js'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    MainNav,
	  IsReturn,
		News,
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js